export const fileUploaderStyles = (theme) => ({
  input: {
    display: 'none',
  },
})
